import { render, staticRenderFns } from "./ObservationsPrintReportTablePage.vue?vue&type=template&id=2ed1d562&"
import script from "./ObservationsPrintReportTablePage.vue?vue&type=script&lang=js&"
export * from "./ObservationsPrintReportTablePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports